export const BILLING_STATUS_COLORS = {
  green:
    "border-transparent bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300",
  yellow:
    "border-transparent bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-300",
  red: "border-transparent bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300",
  grey: "border-transparent bg-gray-100 text-gray-600 dark:bg-slate-700 dark:text-gray-300",
};
